import { useContext, useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { UserContext } from '../context/users';


import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import { Loading, PaginatedTable, TBD } from '../common/variables';
import Modal from 'react-bootstrap/esm/Modal';
import _ from 'lodash';
import { IconButton } from '@material-ui/core';
// import { AppContext } from '../context/app';

export function Users(){
  const { userState : { users , groups } , AddCognitoUser ,GetCognitoGroups , GetCognitoUsers} = useContext(UserContext);
  // const { showAppToast , hideAppToast} = useContext(AppContext);
  const [loading , setLoading] = useState(true);
  const [isAddingUsers , setAddingUsers ]= useState(false);
  const [newEmail, setEmail]= useState("");
  const [newEmails, setEmails]= useState([]);
  const [shareMessage, setShareMessage]= useState("");
  const [perPage , setPerPage] = useState(10);
  useEffect(()=>{
    try{
      setLoading(true);
      GetCognitoUsers();
    }
    catch(err){
      console.log(err);
    }
    finally{
      setTimeout(()=>setLoading(false) ,1000);
    }
  },[]);
  async function handleUsersRefresh(){
    try{
      setLoading(true);
      GetCognitoUsers();
    }
    catch(err){
      console.log(err);
    }
    finally{
      setTimeout(()=>setLoading(false) ,1000);
    }
  }
  useEffect(()=>{
    try{
      GetCognitoGroups();
    }
    catch(err){
      console.log(err);
    }
  },[]);
  const handleEmailEntered = (e)=>{
    e.preventDefault();
    setEmails(_.uniq([...newEmails , newEmail]));
    setEmail("");
  };
  const handleEmailChanged = (e)=>{
      setEmail(e.target.value);
  };
  const handleAddUsers = ()=>{
    try{
      AddCognitoUser(newEmails);
    }
    catch(err){
      console.log(err);
    }
    finally{
      setAddingUsers(false);
    }
  };
  const flattenAttributes = (Attributes)=>{

      let flattened = {};
      for(let index in Attributes){
        const {Name , Value} = Attributes[index];
        flattened[Name] = Value;
      }
      return flattened;
  };
  return(
    <div className="mr-2 p-2  d-flex flex-column">
     <div className="d-flex mb-1 justify-content-between">
        <h4>Users</h4>
        <div className="d-flex align-items-center">
              <Form.Control  style={{width : 100 , marginRight : 4}} as="select" value={perPage} onChange={(e)=>setPerPage(e.target.value)}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </Form.Control>
            <Button size="sm" className="mr-2" onClick={()=>setAddingUsers(true)} ><AddIcon /></Button>
            <Button size="sm" variant="outline-success"   onClick={handleUsersRefresh} ><RefreshIcon/></Button>
        </div>
      </div>
        {
          loading ? <Loading/> : 
          <PaginatedTable  striped bordered hover 
            thead={<tr>
              <th/>
              {TBD && <th>Authentication ID</th>}
              <th>Email</th>
              <th>Type</th>
              <th>Verified</th>
              <th style={{width : 125}}/>
            </tr>}
            renderEmpty={<tr><td style={{textAlign : "center" , padding : 8}} colSpan={5}>No Users</td></tr>}
            renderRowAs={({item : user})=>{
              const attributes = flattenAttributes(user.Attributes);
              return (
                <tr key={user.Username}>
                  <td><Form.Check type="checkbox"/></td>
                  { TBD &&  <td>{attributes.sub}</td>}
                  <td>{attributes.email}</td>
                  <td>{user.group}</td>
                  <td>{attributes.email_verified ? "Verified" : "Unverified"}</td>
                  <td style={{textAlign : "center"}}>
                          <IconButton style={{fontSize :"0.8rem" , outline : "none"}} className="p-0 ml-2 text-warning"><EditIcon style={{fontSize :"0.8rem"}}/></IconButton>
                          <IconButton style={{fontSize :"0.8rem" , outline : "none"}} className="p-0 ml-2 text-danger"><DeleteIcon style={{fontSize :"0.8rem"}}/></IconButton>
                  </td>
                </tr>
              )
            }}
            items={users}
            perPage={perPage}
            />
        }
          <Modal show={isAddingUsers} onHide={()=>setAddingUsers(false)} style={{padding : 5}}>
                <Modal.Header closeButton onHide={()=>setAddingUsers(false)}>
                  <Modal.Title>Add New Users</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleEmailEntered}>
                      <InputGroup style={{alignItems : "center"}}>
                        <Form.Control style={{fontWeight: 400,fontSize: 12,}} type="email" placeholder="Email of User..." className="mr-sm-2" onChange={handleEmailChanged} value={newEmail}/>
                          <span  style={{fontSize : "10px"}} hidden={!newEmail} className="input-group-addon text-muted">press enter &#x23CE;</span>
                      </InputGroup>
                    </Form>
                    <div style={{marginTop: 5,display: "grid",gridTemplateColumns: "repeat(3, 1fr)",justifyItems: "flex-start",columnGap: 5 , gridGap: "1rem"}}>
                        {newEmails.map((user, index)=>{
                            return <Alert variant="primary"  key={index} style={{fontSize:"0.75rem" ,padding : "5px" , width:"auto" }}>{user}</Alert>
                        })}
                    </div>
                    <div>
                        <Form.Control as="textarea" placeholder="Enter Message..." style={{
                                width:"100%",
                                height: 200,
                                resize: "none",
                                overflow: "auto",
                                outline: "none",
                                fontWeight: 400,
                                fontSize: 12,
                        }} value={shareMessage} onChange={(e)=>setShareMessage(e.target.value)}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" disabled={newEmails.length === 0} onClick={handleAddUsers}>Send Invite</Button>
                    <Button variant="light" onClick={()=>setAddingUsers(false)}>Done</Button>
                </Modal.Footer>
            </Modal>

      </div>
    )
}